import styled from "styled-components";

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: red;
  font-size: 12px;
`;

export const OuterContainer = styled.div`
  margin: 5px 0;
`;

export const TextareaContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const TextInputField = styled.input`
  color: white;
  caret-color: white;
  border: none;
  background-color: transparent;
  font-size: 25px;

  &:focus,
  &:active {
    border: none;
    outline: none;
  }

  &::placeholder {
    color: #b0b0b0;
  }

  &::-webkit-input-placeholder {
    /* Chrome, Safari */
    color: #b0b0b0;
  }

  &::-moz-placeholder {
    /* Firefox */
    color: #b0b0b0;
  }
`;

export const DropdownField = {
  control: (provided) => ({
    ...provided,
    color: "white",
    caretColor: "white",
    border: "none",
    boxShadow: "none",
    backgroundColor: "#2a2a3c",
    fontSize: "15px",
    minHeight: "20px",
    height: "20px",
    cursor: "pointer",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "20px",
    padding: "0 6px",
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isHovered ? "#4a4a5c" : "#2a2a3c",
    color: "white",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#4a4a5c",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "white",
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#2a2a3c",
    borderRadius: "10px",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    borderRadius: "10px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "20px",
  }),
};

export const TextareaField = styled.textarea`
  flex: 1;
  height: 400px;
  background: repeating-linear-gradient(
    to bottom,
    #4a4a5c 0,
    #4a4a5c 20px,
    #3a3a4c 20px,
    #3a3a4c 40px
  );
  color: white;
  border-radius: 10px;
  padding: 0 10px;
  caret-color: white;
  border: none;
  font-size: 15px;
  line-height: 20px;
  box-shadow: inset 0 0 20px #4a4a5c;
  resize: none;

  &:focus,
  &:active {
    border: none;
    outline: none;
  }
`;
